module.exports = __webpack_public_path__ + "static/media/help.a7289049.svg";